const Loading = () => {
  return (
    <div className="content-wrapper loading-container">
        <div className='spinner'></div>
        <p>Loading...</p>
    </div>
  );
};

export default Loading;